const PICKUP_SPOT_KINDS = new Set([
  "pickup_spot",
  "pickup",
  "porch_pickup",
  "cooler_pickup",
]);

const FARM_STAND_KINDS = new Set(["farm_stand", "stand", "roadside_stand"]);

const normalizeKind = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const isPickupSpot = (stand = {}) => {
  const explicitKind = normalizeKind(stand.standKind || stand.standType || stand.type);

  if (PICKUP_SPOT_KINDS.has(explicitKind)) return true;
  if (FARM_STAND_KINDS.has(explicitKind)) return false;

  const legacyText = [
    stand.category,
    stand.standName,
    stand.name,
    stand.description,
    stand.locationText,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return /\b(pickup|pick-up|porch|cooler|booth|market booth|drop[- ]?off)\b/.test(legacyText);
};

export const getStandKindLabel = (stand = {}) =>
  isPickupSpot(stand) ? "Pickup Spot" : "Farm Stand";

export const isPublicFarmStand = (stand = {}) =>
  ["active", "open"].includes(String(stand.status || "").toLowerCase()) &&
  stand.isArchived !== true &&
  stand.archived !== true &&
  stand.isDeleted !== true &&
  stand.deleted !== true &&
  stand.isHidden !== true &&
  stand.hidden !== true &&
  stand.isActive !== false;

export const productMatchesFarmStand = (product = {}, stand = {}) => {
  const standId = stand.id;
  if (!standId) return false;

  return [
    product.standId,
    product.farmStandId,
    product.pickupSpotId,
    product.pickupLocationId,
    product.linkedStandId,
    product.linkedPickupSpotId,
  ].some((value) => value === standId);
};

export const getPublicShelfProducts = (products = [], stand = {}) => {
  const standOwnerId = stand.ownerId || stand.userId;

  return products
    .filter((product) => {
      const ownerMatches =
        product.ownerId === standOwnerId ||
        product.userId === standOwnerId ||
        product.sellerId === standOwnerId;
      const standMatches = productMatchesFarmStand(product, stand);
      return ownerMatches && (standMatches || products.length === 1) && product.showOnLiveShelf !== false;
    })
    .slice(0, 4);
};
